import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import insuranceApi from '../../utils/api/insuranceApi';

export const getPackages = createAsyncThunk(
    'insurance/getPackages',
    async () => {
        const { data } = await insuranceApi.get('api/v1/packages');
        return data.data;
    },
);

export const createPackage = createAsyncThunk(
    'insurance/createPackage',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await insuranceApi.post('api/v1/packages', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const getPackageById = createAsyncThunk(
    'insurance/getPackageById',
    async (id) => {
        const { data } = await insuranceApi.get(`api/v1/packages/${id}`);
        return data.data;
    },
);

export const editPackage = createAsyncThunk(
    'insurance/editPackage',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await insuranceApi.put(
                `api/v1/packages/${id}`,
                body,
            );
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deletePackage = createAsyncThunk(
    'insurance/deletePackage',
    async (id, { rejectWithValue }) => {
        try {
            const { data } = await insuranceApi.delete(`api/v1/packages/${id}`);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

const initialState = {
    packagesLoadingStatus: 'idle',
    packageLoadingStatus: 'idle',
    packages: [],
    package: {},
};

export const insuranceSlice = createSlice({
    name: 'insurance',
    initialState,
    reducers: {
        resetPackage(state) {
            state.package = {};
        },
    },
    extraReducers: {
        [getPackages.pending]: (state, action) => {
            state.packagesLoadingStatus = 'loading';
        },
        [getPackages.fulfilled]: (state, action) => {
            state.packagesLoadingStatus = 'succeeded';
            state.packages = action.payload;
        },
        [getPackages.rejected]: (state, action) => {
            state.packagesLoadingStatus = 'failed';
        },
        [getPackageById.pending]: (state, action) => {
            state.packageLoadingStatus = 'loading';
        },
        [getPackageById.fulfilled]: (state, action) => {
            state.packageLoadingStatus = 'succeeded';
            state.package = action.payload;
        },
        [getPackageById.rejected]: (state, action) => {
            state.packageLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allPackages = (state) => state.insurance.packages;
export const packagesLoadingStatus = (state) =>
    state.insurance.packagesLoadingStatus;
export const onePackage = (state) => state.insurance.package;
export const packageLoadingStatus = (state) =>
    state.insurance.packageLoadingStatus;

export const { resetPackage } = insuranceSlice.actions;

export default insuranceSlice.reducer;
